/**
 * External dependencies
 */
import React from "react";

/**
 * Internal dependencies
 */
import { Link } from "../components";
import { slugify } from "../utilities";

export function BreadCrumbList({ categories, productName }) {
  const cats = categories.split(",");
  let firstCat = cats[0].toLowerCase();
  let lastCat = cats[cats.length - 1];

  if (firstCat !== "womens" || firstCat !== "mens") {
    if (productName.toLowerCase().indexOf(`women's`) > -1) {
      firstCat = "Womens";
    } else {
      firstCat = "Mens";
    }
  }

  return (
    <div className="breadcrumb">
      <BreadCrumbItem firstCat={firstCat} lastCat={lastCat} />
    </div>
  );
}

export function BreadCrumbItem({ firstCat, lastCat }) {
  if (!lastCat) {
    return (
      <Link to={`/category/${slugify(firstCat)}`} className="category">
        {firstCat}
      </Link>
    );
  }
  return (
    <>
      <Link to={`/category/${slugify(firstCat)}`} className="category">
        {firstCat}
      </Link>
      <Link
        to={`/category/${slugify(firstCat)}/${slugify(lastCat)}`}
        className="category"
      >
        {lastCat}
      </Link>
    </>
  );
}
